module.exports = __webpack_public_path__ + "media/images/blog/02-4b3c3baad374ed34d62576623df1aead.jpg";